import React from "react"
import PropTypes from "prop-types"
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts'; 

class DeckStatsTypes extends React.Component {
  constructor(props) {
    super(props);
  }

  render () {
    // Leave room for full horizontal card-type labels when
    // four card types place a tick at the edge of the 300px chart.
		const renderLineChart = (
    <RadarChart
      cx="50%"
      cy="50%"
      outerRadius={50}
      width={300}
      height={200}
      data={this.props.data}
    >
      <PolarGrid />
      <PolarAngleAxis dataKey="name" />
      {/* Three horizontal numeric labels fit the compact radius without stacking. */}
      <PolarRadiusAxis angle={90} tickCount={3} stroke="#666" tick={{ dx: 6, dy: 12 }} />
      <Radar
        name="CardTypes"
        dataKey="count"
        stroke="#8884d8"
        fill="#8884d8"
        fillOpacity={0.6}
      />
    </RadarChart>

    );

    return (<div className="deck-stats-mana-values">
			<h4 className="deck-stats-title">Card Types</h4>
      {renderLineChart}
      </div>);
  }
}

DeckStatsTypes.propTypes = {
  data: PropTypes.array
};
export default DeckStatsTypes
